import { useState, useMemo } from 'react'
import { Dialog, DialogPanel } from '@headlessui/react'
import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline'
import { Link, useLocation } from '@tanstack/react-router'
import { clsx } from 'clsx'
import VideoStatusDot from './VideoStatusDot'
import HeaderLoginButton from './HeaderLoginButton'
import { faScrollOld } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useAccount } from '../contexts/AccountContext' // Adjust the import path as needed
import BetaBadge from './inline/BetaBadge'

/** Navbar */
export default function Header() {
  const { state: { isAuthenticated } } = useAccount()
  const pathname = useLocation().pathname
  const forceDark = pathname === '/' || pathname.startsWith('/watch/')
  return (
      <header className={clsx("px-6 py-4 flex justify-between items-center shadow-sm", forceDark ? "bg-mist-950" : "bg-white dark:bg-mist-950")}>
        <Link to={isAuthenticated ? '/today' : '/'} className="text-2xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-purple-600 to-orange-500 relative inline-flex">
          Sermon Slides
          {/* <BetaBadge angled /> */}
        </Link>
        <div className="flex gap-4">
          <HeaderLoginButton forceDark={forceDark} />
        </div>
      </header>);
}



function OldHeader() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)
  const { state: {isAuthenticated} } = useAccount() // Adjust based on your actual context structure
  
  const navigation = useMemo(() => {
    const items = [
      { name: 'Quick Start', href: '/quick/start' },
      { name: 'Capture', href: '/capture' },
      // { name: 'Home', href: '/' },
      // { name: 'Company', href: '#' },
    ]
    
    if (isAuthenticated) {
      items.push({ name: 'Venues', href: '/venues' })
    }
    
    return items
  }, [isAuthenticated])

  return (
    <header className="bg-white dark:bg-mist-950">
      <nav aria-label="Global" className="mx-auto flex max-w-7xl items-center justify-between p-2 lg:px-8">
        <div className="flex items-center gap-x-12">
          <Link to={isAuthenticated ? '/today' : "/"} className="-m-1.5 p-1.5">
            <span className="sr-only">Sermon Slides</span>
            <FontAwesomeIcon icon={faScrollOld} className="text-lg h-12 w-12 text-teal-600 dark:text-teal-400" />
          </Link>
          <div className="hidden lg:flex lg:gap-x-12">
            {navigation.map((item) => (
              <Link key={item.name} to={item.href} className="text-sm/6 font-semibold text-gray-900 dark:text-white">
                {item.name}
              </Link>
            ))}
          </div>
        </div>
        <div className="flex lg:hidden">
          <button
            type="button"
            onClick={() => setMobileMenuOpen(true)}
            className="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-gray-700 dark:text-mist-500 dark:hover:text-white"
          >
            <span className="sr-only">Open main menu</span>
            <Bars3Icon aria-hidden="true" className="size-6" />
          </button>
        </div>
        <div className="hidden lg:flex lg:items-center lg:gap-x-4">
          <VideoStatusDot />
          <HeaderLoginButton className="text-sm/6 font-semibold text-gray-900 dark:text-white" />
        </div>
      </nav>
      <Dialog open={mobileMenuOpen} onClose={setMobileMenuOpen} className="lg:hidden">
        <div className="fixed inset-0 z-50" />
        <DialogPanel className="fixed inset-y-0 right-0 z-50 w-full overflow-y-auto bg-white p-6 sm:max-w-sm sm:ring-1 sm:ring-gray-900/10 dark:bg-mist-950 dark:sm:ring-mist-200/10">
          <div className="flex items-center justify-between">
            <Link to="/" className="-m-1.5 p-1.5">
              <span className="sr-only">Your Company</span>
              <img
                alt=""
                src="https://tailwindcss.com/plus-assets/img/logos/mark.svg?color=indigo&shade=600"
                className="h-8 w-auto dark:hidden"
              />
              <img
                alt=""
                src="https://tailwindcss.com/plus-assets/img/logos/mark.svg?color=indigo&shade=500"
                className="h-8 w-auto not-dark:hidden"
              />
            </Link>
            <button
              type="button"
              onClick={() => setMobileMenuOpen(false)}
              className="-m-2.5 rounded-md p-2.5 text-gray-700 dark:text-mist-500 dark:hover:text-white"
            >
              <span className="sr-only">Close menu</span>
              <XMarkIcon aria-hidden="true" className="size-6" />
            </button>
          </div>
          <div className="mt-6 flow-root">
            <div className="-my-6 divide-y divide-gray-500/10 dark:divide-white/10">
              <div className="space-y-2 py-6">
                {navigation.map((item) => (
                  <Link
                    key={item.name}
                    to={item.href}
                    className="-mx-3 block rounded-lg px-3 py-2 text-base/7 font-semibold text-gray-900 hover:bg-gray-50 dark:text-white dark:hover:bg-white/5"
                  >
                    {item.name}
                  </Link>
                ))}
              </div>
              <div className="py-6 space-y-4">
                <div className="px-3">
                  <VideoStatusDot />
                </div>
                <HeaderLoginButton className="-mx-3 block rounded-lg px-3 py-2.5 text-base/7 font-semibold text-gray-900 hover:bg-gray-50 dark:text-white dark:hover:bg-white/5" />
              </div>
            </div>
          </div>
        </DialogPanel>
      </Dialog>
    </header>
  )
}